import { createModel } from "hox";
import { useState } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { tasteService } from "./tasteService";
import { ISearchPage } from "@/types/AppTypes";
import { FoodCategory, IMealTypeEnum } from "@/types/AppEnums";
import { ILibraryDetial, ILibraryFields, ILibrarySearch } from "@/views/food/library/libraryTypes"
import { libraryService } from "@/views/food/library/libraryService"
import { IMealFields } from "@/views/meal/mealTypes";
import moment from "moment"
import { globalPrompt } from "@/components/message";
import { useLockFn } from "ahooks";
import { IFoods, ITasteDetial, ITasteFields } from "./tasteType";
import useGlobalModel from "@/model/globalModel";
export interface IHomeInfo {
    "canteenId"?: string,
    "mealId": string,
}
export interface ITimeStartInEnd {
    "startTime": string,// "2021-05-01",
    "endTime": string,// "2021-07-01"
}
export interface IMealSearchParam {
    name: string,
    category: FoodCategory
}
export const useTasteModel = createModel(function () {
    const { user: { canteenId } } = useGlobalModel(({ user }) => [user])
    // 餐厅id
    const [homeInfo, setHomeInfo] = useState<IHomeInfo | null>(null)
    //餐别分类
    const [meal, setMeal] = useState<IMealTypeEnum>(IMealTypeEnum.LUNCH)
    //餐别分类数组
    const [mealIdList, setMealIdList] = useState<IMealFields[]>([])

    //列表数据源
    const [dataSource, setDataSource] = useState<ITasteDetial[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ITasteFields>({});

    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //菜品列表
    const [mealList, setMealList] = useState<ILibraryDetial[]>([]);
    const initMealSearchParam = {
        name: "",
        category: FoodCategory.cold
    }
    const [mealSearchParam, setMealSearchParam] = useState<ILibraryFields>(initMealSearchParam)
    //当日菜品
    const [dayMeal, setDayMeal] = useState<ITasteDetial>({});
    //选中的原材料
    const [selectMaterial, setSelectMaterial] = useState<IFoods>({})
    //日历时间当前月的起始时间
    const initTimeStartInEnd: ITimeStartInEnd = {
        startTime: moment().startOf('month').format("YYYY-MM-DD"),
        endTime: moment().endOf('month').endOf('month').format("YYYY-MM-DD")
    }
    const [timeStartInEnd, setTimeStartInEnd] = useState<ITimeStartInEnd>(initTimeStartInEnd)

    //对应菜单的菜品及预约数量
    const [tasteList, setTasteList] = useState<any[]>([]);
    const loadData = async (searchValue: ITasteFields = searchParam) => {
        let searchParams = {
            ...timeStartInEnd,
            ...searchValue,
            canteenId,
            type: "booking"
        }
        let { retData } = await tasteService.findByMeal(searchParams);
        setDataSource(retData)
    }

    //设置搜索value
    const updateSearchParam = (updateParam: ITasteFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        loadData({});
    }

    //菜品列表
    const loadLibrary = async (page?: ISearchPage, searchValue: ILibrarySearch = mealSearchParam) => {
        let pam: any = {}
        for (let i in searchValue) {
            if (searchValue[i]) {
                pam[i] = searchValue[i]
            }
        }
        const searchParams = {
            ...pam,
            page: {
                pageSize: 1000,
                pageNum: 1
            }
        }
        let { retData } = await libraryService.page(searchParams);
        let { data, ...pg } = retData;
        let newData = data.map(item => {
            return {
                ...item,
                enable: 0
            }
        })
        setMealList(newData)
    }
    //设置搜索value
    const updateLibrarySearchParam = (updateParam: ILibrarySearch) => {
        setMealSearchParam({ ...mealSearchParam, ...updateParam })
    }
    //重置搜索参数
    const resetLibrarySearchParam = () => {
        setMealSearchParam({ category: mealSearchParam.category });
        loadLibrary(initPgCfg, { category: mealSearchParam.category });
    }

    return {
        dataSource, canteenId,
        tasteList, setTasteList,
        searchParam,
        initPgCfg,
        setDataSource,
        setSearchParam,
        loadData,
        updateSearchParam,
        resetSearchParam,
        loadLibrary,
        mealList, setMealList,
        mealSearchParam, setMealSearchParam,
        dayMeal, setDayMeal,
        homeInfo, setHomeInfo,
        meal, setMeal,
        mealIdList, setMealIdList,
        timeStartInEnd, setTimeStartInEnd,
        updateLibrarySearchParam,
        resetLibrarySearchParam,
        selectMaterial, setSelectMaterial
    }
})